import React, { lazy, Suspense } from "react";
import { connect } from "react-redux";
import "./stylings/App.scss";
import "suneditor/dist/css/suneditor.min.css";
import IdleTimerContainer from "./components/timer/idleTimer/IdleTimerContainer";
import LazyLoader from "./components/common/loader/LazyLoader";
import NavBar from "./components/navigations/NavBar";

const SikkaPrimeApp = lazy(() => import("./SikkaPrimeApp"));

function App({ userInfo }) {
    return (
        <div className="app">
            <IdleTimerContainer />

            {userInfo?.masterId && userInfo?.apiToken && <NavBar />}

            <Suspense fallback={<LazyLoader />}>
                <SikkaPrimeApp />
            </Suspense>
        </div>
    );
}

const mapStateToProps = (state) => ({
    userInfo: state.dataReducer.userInfo,
});

export default connect(mapStateToProps, null)(App);
